import React from "react";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  IconButton,
  Checkbox,
  Button,
  Box,
} from "@mui/material";
import { Add, DeleteOutline } from "@mui/icons-material";

const PaymentMethod = ({ formData, setFormData, setIsChanged, nameErrors }: any) => {
  const tableHeadings = [
    { label: "Dropdown Text", align: "center" },
    { label: "Description", align: "center" },
    { label: "Action", align: "center" },
  ];

  // Ensure one default row exists
  const paymentMethod = formData?.payment_methods?.length
    ? formData.payment_methods
    : [
        {
          name: "",
          description: "",
          is_editable: true,
          is_deletable: true,
          is_delete: false,
        },
      ];
  // Handle input change
  const handleInputChange = (
    index: number,
    field: string,
    value: string | boolean
  ) => {
    const updated = paymentMethod.map((item: any) => ({ ...item }));
    updated[index][field] = value;
    setFormData((prev: any) => ({
      ...prev,
      payment_methods: updated,
    }));
    setIsChanged(true);
  };

  // Add new row
  const handleAddRow = () => {
    const updated = [
      ...paymentMethod,
      {
        name: "",
        description: "",
        is_editable: true,
        is_deletable: true,
        is_delete: false,
      },
    ];
    setFormData((prev: any) => ({
      ...prev,
      payment_methods: updated,
    }));
    setIsChanged(true);
  };

  // Delete row
  const handleDelete = (index: number) => {
    const updated = paymentMethod.filter((_: any, i: number) => i !== index);
    if (updated.length === 0)
      updated.push({
        name: "",
        description: "",
        is_editable: true,
        is_deletable: true,
        is_delete: false,
      });
    setFormData((prev: any) => ({
      ...prev,
      payment_methods: updated,
    }));
    setIsChanged(true);
  };

  return (
    <Grid item xs={12} md={12}>
      <Paper
        sx={{
          p: 2,
          borderRadius: "16px",
          backgroundColor: "#f8f9fa",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        }}
      >
        <Typography
          sx={{
            textTransform: "uppercase",
            fontWeight: 600,
            color: "#02906F",
            mb: 2,
            fontSize: "1rem",
          }}
        >
          Payment Methods
        </Typography>

        <TableContainer
          component={Paper}
          sx={{
            borderRadius: "12px",
            overflowX: "auto",
            maxHeight: 350,
          }}
        >
          <Table aria-label="invoice-types-table">
            <TableHead>
              <TableRow
                sx={{
                  background: "#02906F !important",
                  "& th": {
                    color: "#fff",
                    fontWeight: 600,
                    textAlign: "center",
                    padding: "10px",
                  },
                }}
              >
                {tableHeadings.map((head, i) => (
                  <TableCell key={i}>{head.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {paymentMethod.map((row: any, index: number) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": { backgroundColor: "#e9f6f3" },
                    transition: "background 0.3s",
                  }}
                >
                  {/* Dropdown Text */}
                  <TableCell
                    sx={{
                      textAlign: "center",
                      padding: "4px 16px",
                      height: "0px",
                    }}
                  >
                    <TextField
                      fullWidth
                      size="small"
                      value={row.name}
                      disabled={!row?.is_editable}
                      onChange={(e) =>
                        handleInputChange(index, "name", e.target.value)
                      }
                      inputProps={{
                        style: { textAlign: "left", height: "16px" },
                      }}
                      placeholder="Enter dropdown text"
                      error={!!(nameErrors && nameErrors[index])}
                      // helperText={nameErrors && nameErrors[index] ? nameErrors[index] : ""}
                    />
                  </TableCell>

                  {/* Description */}
                  <TableCell
                    sx={{
                      textAlign: "center",
                      padding: "4px 16px",
                      height: "0px",
                    }}
                  >
                    <TextField
                      fullWidth
                      size="small"
                      disabled={!row?.is_editable}
                      value={row.description}
                      onChange={(e) =>
                        handleInputChange(index, "description", e.target.value)
                      }
                      inputProps={{
                        style: { textAlign: "left", height: "16px" },
                      }}
                      placeholder="Enter description"
                    />
                  </TableCell>
                  {/* Action Buttons */}
                  <TableCell
                    sx={{
                      textAlign: "center",
                      padding: "0px 16px",
                      height: "0px",
                    }}
                  >
                    {row?.is_deletable && (
                      <IconButton
                        color="error"
                        onClick={() => handleDelete(index)}
                      >
                        <DeleteOutline />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* ➕ Add Button */}
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            variant="outlined"
            startIcon={<Add />}
            onClick={handleAddRow}
            sx={{
              // backgroundColor: "#02906F",
              // "&:hover": { backgroundColor: "#037d62" },
              textTransform: "capitalize",
              fontWeight: 500,
              px: 3,
              py: 0.5,
              borderRadius: "8px",
            }}
          >
            Add More
          </Button>
        </Box>
      </Paper>
    </Grid>
  );
};

export default PaymentMethod;
